module.exports = __webpack_public_path__ + "components/media-kit/static/icon-europe-e8a7acf5ca465333620fa39c945bfd0c.svg";